import { StateCreator, create } from 'zustand';

import { Address } from '@generated/gql/graphql';

import {
  FORM_ABOUT_PREVIOUS_ADDRESS,
  FORM_ADDRESS_PAGE,
  FORM_DD_BILLING_ADDRESS,
} from '../constants';

interface AddressState {
  addresses: Address[];
  selectedAddress: Address | null;
  hasFetchedAddresses: boolean;
  setAddresses: (addresses: Address[]) => void;
  setSelectedAddress: (address: Address) => void;
  setHasFetchedAddresses: (fetched: boolean) => void;
}

type AddressStoreState = {
  [name: string]: AddressState;
};

const createAddressSlice =
  (name: string): StateCreator<AddressStoreState> =>
  (set) => ({
    [name]: {
      addresses: [],
      selectedAddress: null,
      hasFetchedAddresses: false,
      setAddresses: (addresses) =>
        set((state) => ({ ...state, [name]: { ...state[name], addresses } })),
      setSelectedAddress: (address) =>
        set((state) => ({
          ...state,
          [name]: { ...state[name], selectedAddress: address },
        })),
      setHasFetchedAddresses: (hasFetchedAddresses) =>
        set((state) => ({
          ...state,
          [name]: { ...state[name], hasFetchedAddresses },
        })),
    },
  });

const useStore = create<AddressStoreState>()((...args) => ({
  ...createAddressSlice(FORM_ADDRESS_PAGE)(...args),
  ...createAddressSlice(FORM_ABOUT_PREVIOUS_ADDRESS)(...args),
  ...createAddressSlice(FORM_DD_BILLING_ADDRESS)(...args),
}));

export { useStore };
